import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { organizationSelector } from '../../../redux/modules/organization/selectors';
import { customRelationsEnabledSelector } from '../../../redux/modules/organizationGroup/selectors';
import {
  CustomRelationSubtype,
  Organization,
} from '../../../types/organization';

type CustomRelationsConfig = {
  isEnabled: boolean;
  allowedSubtypes: CustomRelationSubtype[];
};

export const resolveCustomRelationsConfig = ({
  isToggleEnabled,
  uiSettings,
}: {
  isToggleEnabled: boolean;
  uiSettings: Organization['uiSettings'] | undefined;
}): CustomRelationsConfig => {
  const allowedSubtypes = (
    uiSettings?.custom_relations?.allowed_names ?? []
  ).flatMap(entry =>
    entry.name && entry.label ? [{ name: entry.name, label: entry.label }] : []
  );

  return {
    isEnabled: isToggleEnabled && allowedSubtypes.length > 0,
    allowedSubtypes,
  };
};

export const useCustomRelationsConfig = (): CustomRelationsConfig => {
  const isToggleEnabled = useSelector(customRelationsEnabledSelector);
  const { uiSettings } = useSelector(organizationSelector);

  return useMemo(
    () => resolveCustomRelationsConfig({ isToggleEnabled, uiSettings }),
    [isToggleEnabled, uiSettings]
  );
};
